module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cat"
  }, [(_vm.isTutorialChecked) ? _c('CatTutorial') : _vm._e(), _vm._v(" "), (_vm.isOpenPrimeModal) ? _c('PrimeModal', {
    on: {
      "closeModal": function($event) {
        return _vm.closePrimeModal()
      },
      "okModal": function($event) {
        return _vm.okPrimeModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenLicenceModal) ? _c('LicenceModal', {
    on: {
      "ok": function($event) {
        _vm.isLicenceModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('NavigationBar'), _vm._v(" "), _c('CatHeader'), _vm._v(" "), (!_vm.isParentUser) ? [_c('ActiveAssignment'), _vm._v(" "), _c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.sam_recommend_video_lecture',
      "routeName": 'recommend-video-lecture'
    }
  }), _vm._v(" "), _c('VideoLecture'), _vm._v(" "), _c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.sam_recommend_card_lecture',
      "routeName": 'recommend-card-lecture'
    }
  }), _vm._v(" "), _c('CardLecture'), _vm._v(" "), _c('CatDomain', {
    staticClass: "cl-container"
  })] : _vm._e(), _vm._v(" "), (!_vm.isParentUser) ? [_c('CatProficiency')] : _vm._e(), _vm._v(" "), (_vm.isParentUser) ? [_c('CatParentView')] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2924b444","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/views/CatMain.vue
// module id = 1562
// module chunks = 1